var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.innerValue && _vm.innerValue['@type'] === 'LOCK')?_c('dynamic-document-lock-event-configuration-template',{model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }